import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 px-4 py-2.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm text-white text-sm whitespace-nowrap cursor-pointer hover:bg-white/20 transition-colors"
      >
        <span>Browse Categories</span>
        <i className={`ri-arrow-down-s-line text-sm transition-transform ${open ? "rotate-180" : ""}`}></i>
      </button>

      {open && (
        <div className="absolute top-full mt-2 left-0 bg-background-50 rounded-xl border border-background-200/70 shadow-lg py-2 w-56 max-h-80 overflow-y-auto z-50">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="block px-4 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 whitespace-nowrap cursor-pointer transition-colors"
              onClick={() => setOpen(false)}
            >
              {cat.name}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}